import _objectSpread from "/_target_repo_ai-ppt/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import axios from 'axios';
import { loginConfig } from './loginConfig.js';
import { getParameter } from '../../../utils';

import { ref, onMounted, nextTick } from 'vue';
const loginUrlHost = '//dict.youdao.com/login/acc/login?cf=7&app=web&product=DICT';
const header = '登录使用完整功能';
export default {
  __name: 'IndexPage',
  props: {
    hideLoginBoxClose: {
      type: Boolean
    },
    redirectUrl: {
      type: String,
      default: ''
    },
    product: {
      type: String,
      default: ''
    },
    host: {
      type: String,
      default: ''
    },
    promark: {
      type: String,
      default: ''
    },
    captchaKey: {
      type: String,
      default: ''
    }
  },
  emits: ['closeclick', 'loginfail', 'loginsuccess'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    __expose();
    const props = __props;
    const URS = ref(null);
    const otherLoginConfig = [{
      name: '微信登录',
      class: 'weixin',
      alt: 'weixin',
      src: 'weixin@2x.png',
      type: 'weixin'
    }, {
      name: '',
      class: 'qq',
      alt: 'QQ',
      src: 'qq@2x.png',
      type: 'qq'
    }, {
      name: '',
      class: 'weibo',
      alt: 'weibo',
      src: 'weibo@2x.png',
      type: 'weibo'
    }, {
      name: '',
      class: 'apple_id',
      alt: 'AppleId',
      src: 'apple@2x.png',
      type: 'AppleId'
    }];
    const emits = __emit;
    onMounted(() => {
      const requireUrl = props.redirectUrl || getParameter('redirect_url');
      const product = props.product || getParameter('product') || 'dict_logon';
      const host = props.host || getParameter('host') || 'c.youdao.com';
      const promark = props.promark || getParameter('promark') || 'akOJysI';
      const captchaKey = props.captchaKey || getParameter('captchaKey') || '1b1d6355ebc74e4b928c297aefe2d769';
      axios.defaults.withCredentials = true;
      const config = _objectSpread(_objectSpread({
        product,
        promark,
        host,
        captchaKey
      }, loginConfig), {}, {
        logincb: json => {
          // json 是返回了用户登陆的账号 如果是适用的邮箱形式，则必然含有 '@'

          const tp = json.indexOf('@') !== -1 ? 'urscookie' : 'urs-phone-web';
          const url = `${loginUrlHost}&tp=${tp}`;
          axios.get(url).then(() => {
            if (requireUrl && requireUrl !== window.location.href) {
              window.location.href = requireUrl;
            } else {
              emits('loginsuccess', json);
            }
          }).catch(err => {
            if (requireUrl && requireUrl !== window.location.href) {
              window.location.href = requireUrl;
            } else {
              emits('loginfail');
            }
          });
        }
      });
      nextTick(() => {
        /* eslint-disable-next-line */
        URS.value = new window.URS(config);
      });
    });
    const login = way => {
      // 体验版批改成功再登录？如果没有批改成功就登录成功，登录后的文章也保存不准确; 或者增加异常提示.
      const requireUrl = props.redirectUrl || getParameter('redirect_url');
      const host = `${loginUrlHost}&fr=1&tp=apple-web-dict`;
      if (way === 'AppleId') {
        window.location.href = `${host}&ru=${encodeURIComponent(requireUrl)}`;
      } else {
        window.yd.account.login(way, requireUrl);
      }
    };
    const mobileLoginRef = ref(null);
    const onCloseClick = () => {
      mobileLoginRef.value.innerHTML = '';
      emits('closeclick');
    };
    const __returned__ = {
      props,
      loginUrlHost,
      URS,
      header,
      otherLoginConfig,
      emits,
      login,
      mobileLoginRef,
      onCloseClick,
      get axios() {
        return axios;
      },
      get loginConfig() {
        return loginConfig;
      },
      get getParameter() {
        return getParameter;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};